export const stateName = 'session';